


export const MyChangePassword_START = 'MyChangePassword_START';
export const MyChangePassword_END = 'MyChangePassword_END';
export const MyChangePassword_ERROR = 'MyChangePassword_ERROR';
export const MyChangePassword_SUCCESS = 'MyChangePassword_SUCCESS';
export const MyChangePassword_FAIL = 'MyChangePassword_FAIL';
export const IsDataSubmitedSuccessfullyChangePassword = 'IsDataSubmitedSuccessfullyChangePassword'